// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInSeconds as fn } from "../differenceInSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInSeconds = convertToFP(fn, 2);

// Fallback for modularized imports:
export default differenceInSeconds;
